import React, { useEffect, useRef } from 'react'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const FadeInBottomEffect = ({
  children,
  tagName = 'div',
  className,
  ...props
}) => {
  const TagName = tagName
  const refFadeInBottomEffect = useRef(null)

  useEffect(() => {
    if (window && document) {
      gsap.registerPlugin(ScrollTrigger)

      if (refFadeInBottomEffect.current !== null) {
        window.setTimeout(() => {
          ScrollTrigger.create({
            trigger: refFadeInBottomEffect.current,
            start: 'start 85%',
            end: 99999,
            onEnter: () => {
              refFadeInBottomEffect.current?.classList.add('fade-in-bottom-active')
            },
            onLeaveBack: () => {
              refFadeInBottomEffect.current?.classList.remove(
                'fade-in-bottom-active'
              )
            },
          })
        }, 400)
      }
    }
  }, [])

  return (
    <TagName
      ref={refFadeInBottomEffect}
      className={className + ' fade-in-bottom'}
      {...props}
    >
      {children}
    </TagName>
  )
}

export default FadeInBottomEffect
